import React, { Component } from 'react'
import { EndCallAgentProfileTheme } from 'modules/theme'

export class EndCallAgentProfile extends Component {
    render() {
        return (
            <EndCallAgentProfileTheme
                userImg={'images/Profile.png'}
                agentName={'Charlotte Jones'}
                onChangeSelect={''}
                tagValue={''}
                optionsTag={''}
                changePwd={'Change Password'}
                changePwdClick={''}
                dashboard={'Dashboard'}
                dashboardClick={''}
            />
        )
    }
}

export default EndCallAgentProfile


// WEBPACK FOOTER //
// src/dialpad/components/layout/EndCallAgentProfile.js